import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';

import { TagStyled } from './Tag.styled';

const Tag = ({
  as,
  children,
  modifiers,
}) => (
  <TagStyled modifiers={modifiers} as={as}>
    {children}
  </TagStyled>
);

Tag.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  modifiers: CustomTypes.oneOrMore([
    '',
    'primary',
    'success',
    'warning',
    'danger',
    'gradient',
  ]),
};

Tag.defaultProps = {
  as: '',
  children: null,
  modifiers: '',
};

export default Tag;
